import api from '@/apis'

export default {
  state: {
    datepicker: { date: [] },
    files_table: {
      loading: false,
      headers: [
        { text: 'Name', value: 'file_name', width: '190' },
        { text: '', value: 'management', sortable: false, width: '144' }
      ],
      items: [],
      options: null,
      total_items: null
    },
    search: ''
  },
  mutations: {
    SET_AUDIO_FILE_TO_TEXT_CARD_DATEPICKER_DATE(state, payload) {
      state.datepicker.date = payload
    },
    SET_AUDIO_FILE_TO_TEXT_CARD_FILES_TABLE_OPTIONS(state, payload) {
      state.files_table.options = payload
    },
    SET_AUDIO_FILE_TO_TEXT_CARD_FILES_TABLE_LOADING(state, payload) {
      state.files_table.loading = payload
    },
    SET_AUDIO_FILE_TO_TEXT_CARD_FILES_TABLE_ITEMS(state, payload) {
      state.files_table.items = payload
    },
    SET_AUDIO_FILE_TO_TEXT_CARD_FILES_TABLE_TOTAL_ITEMS(state, payload) {
      state.files_table.total_items = payload
    },
    SET_AUDIO_FILE_TO_TEXT_CARD_SEARCH(state, payload) {
      state.search = payload
    }
  },
  actions: {
    async initAudioFileToTextTable({ rootState, state, commit }, payload) {
      try {
        commit('SET_AUDIO_FILE_TO_TEXT_CARD_SEARCH', payload.search)
        commit('SET_AUDIO_FILE_TO_TEXT_CARD_FILES_TABLE_LOADING', true)
        const { page, itemsPerPage } = state.files_table.options
        let date_from = null
        let date_to = null
        if (state.datepicker.date.length === 1) {
          date_from = state.datepicker.date[0]
          date_to = state.datepicker.date[0]
        } else if (state.datepicker.date.length === 2) {
          date_from = state.datepicker.date[0]
          date_to = state.datepicker.date[1]
        }
        const search = state.search === '' ? null : state.search
        const data = {
          params: { search: search, date_from: date_from, date_to: date_to, limit: itemsPerPage, offset: page * itemsPerPage - itemsPerPage },
          project_id: rootState.auth.project_id,
          headers: {
            headers: {
              access_token: process.env.VUE_APP_AUDIO_FILE_TO_TEXT_AUTH_TOKEN
            }
          }
        }
        const response = await api.getAudioFileList(data)
        if (response.data.success) {
          commit('SET_AUDIO_FILE_TO_TEXT_CARD_FILES_TABLE_ITEMS', response.data.data)
          commit('SET_AUDIO_FILE_TO_TEXT_CARD_FILES_TABLE_TOTAL_ITEMS', response.data.total)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_AUDIO_FILE_TO_TEXT_CARD_FILES_TABLE_LOADING', false)
      }
    },
    async initAudioFileToTextResultCard({ rootState, commit }, payload) {
      try {
        commit('SET_AUDIO_FILE_TO_TEXT_RESULT_CARD_VISIBILITY', false)
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Loading...', loading: true })

        const data = {
          params: { task_id: payload, project_id: rootState.auth.project_id },
          headers: {
            headers: {
              access_token: process.env.VUE_APP_AUDIO_FILE_TO_TEXT_AUTH_TOKEN
            }
          }
        }

        const response = await api.getAudioFileResult(data)
        if (response.data.success) {
          commit('SET_AUDIO_FILE_TO_TEXT_RESULT_CARD_RESULT', response.data.data)
          commit('SET_AUDIO_FILE_TO_TEXT_RESULT_CARD_VISIBILITY', true)
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async updateAudioTask({ rootState, commit, dispatch }, payload) {
      try {
        const action = payload.status === 'paused' ? 'resume' : 'pause'
        const loading_action_text = payload.status === 'pause' ? 'Resuming task' : 'Pausing task'
        const data = {
          project_id: rootState.auth.project_id,
          task_id: payload.task_id,
          params: { action: action },
          headers: {
            headers: {
              access_token: process.env.VUE_APP_AUDIO_FILE_TO_TEXT_AUTH_TOKEN
            }
          }
        }
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: loading_action_text, loading: true })
        const response = await api.updateAudioTask(data)
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
          dispatch('initAudioFileToTextTable', { search: '' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
